import * as constAction from 'root/actionConstants';

/**
 * Setea un campo o el reducer completo del componente con el default.
 * @param {string} value Nombre del campo a limpiar ("all" para todo el reducer).
 * @returns {Object}
 */
export const clear = (value) => ({
  type: constAction.RESERVAS_CLEAR,
  payload: value,
});

export const setState = (payload) => ({
  type: constAction.RESERVAS_SET_STATE,
  payload: payload,
});

export const getById = (id) => ({
  type: constAction.RESERVAS_GET_BY_ID,
  payload: { reservaId: id },
  epic: {
    url: 'reservas/getPasajerosById',
    method: 'GET',
  },
});

export const setStateById = (result) => ({
  type: constAction.RESERVAS_SET_STATE_BY_ID,
  payload: result,
});

export const setTemporal = (viajeId, qty) => ({
  type: constAction.RESERVAS_TEMPORAL_SET,
  payload: {
    qty,
    viajeId,
  },
  epic: {
    url: 'reservas/createTmp',
    method: 'POST',
  },
});

export const set = (data, force) => ({
  type: constAction.RESERVAS_SET,
  payload: {
    ...data,
    force,
  },
  epic: {
    url: data.reservaId ? 'reservas/editarReserva' : 'reservas/nuevaReserva',
    method: 'POST',
  },
});

export const deleteTemporal = (viajeId) => ({
  type: constAction.RESERVAS_TEMPORAL_DELETE,
  payload: {
    viajeId,
  },
  epic: {
    url: 'reservas/deleteTmp',
    method: 'POST',
  },
});

export const cancelarReserva = (reservaId, cancelada, reservaPrevia, refreshAbonado, noPenalizar) => ({
  type: constAction.RESERVAS_CANCELAR,
  refreshAbonado,
  payload: {
    reservaId,
    cancelada,
    reservaPrevia,
    noPenalizar,
  },
  epic: {
    url: 'reservas/cancelarReserva',
    method: 'POST',
  },
});

export const concretarReserva = (reservaId, concretada, viajeId, setInAbonados) => ({
  type: constAction.RESERVAS_CONCRETAR,
  setInAbonados,
  payload: {
    reservaId,
    concretada,
    viajeId,
  },
  epic: {
    url: 'reservas/concretar',
    method: 'POST',
  },
});

export const abonarReserva = (reservaId, abonada, viajeId, cuentaCorriente) => ({
  type: constAction.RESERVAS_ABONAR,
  viajeId,
  payload: {
    reservaId,
    abonada,
    cuentaCorriente,
  },
  epic: {
    url: 'reservas/abonar',
    method: 'POST',
  },
});

export const delReservaPrevia = (reservaId) => ({
  type: constAction.RESERVAS_DEL_PREVIA,
  payload: reservaId,
});

export const getReservasPendientes = () => ({
  type: constAction.RESERVAS_GET_PENDIENTES,
  epic: {
    url: 'reservasPendientes/getAll',
    method: 'GET',
  },
});

export const tryProbable = (reservaProbableId) => ({
  type: constAction.RESERVAS_SET_PROBABLES,
  payload: { reservaProbableId },
  epic: {
    url: 'reservasProbables/generarReserva',
    method: 'POST',
  },
});

//-- ACCIONES DE OTROS COMPONENTES -- //
export const getViajeById = (viajeId, paradas) => ({
  type: constAction.RESERVAS_VIAJES_GET_BY_ID,
  payload: { viajeId, paradas: paradas ? true : false },
  epic: {
    url: 'viajes/getFull',
    method: 'GET',
  },
});

export const getByDoc = (documento) => ({
  type: constAction.RESERVAS_PASAJEROS_GET_BY_DOCUMENTO,
  payload: { documento },
  epic: {
    url: 'usuarios/getUsuarioByDoc',
    method: 'GET',
  },
});



// WEBPACK FOOTER //
// src/modules/reservas/action.js